"use strict";

require("core-js/modules/es6.array.filter.js");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.array.map.js");
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));
var _entries = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/entries"));
var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/parse-int"));
var _section = require("@nucleo/section");
var _model = _interopRequireDefault(require("./model"));
function cov_1p97rk1ej9() {
  var path = "/codebuild/output/src1689451169/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/calendar/lib/reducer.js";
  var hash = "1daafc55ef017461610d0a23c47b57a33c7b9dcc";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1689451169/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/nucleo/calendar/lib/reducer.js",
    statementMap: {
      "0": {
        start: {
          line: 4,
          column: 36
        },
        end: {
          line: 10,
          column: 1
        }
      },
      "1": {
        start: {
          line: 12,
          column: 33
        },
        end: {
          line: 12,
          column: 163
        }
      },
      "2": {
        start: {
          line: 12,
          column: 46
        },
        end: {
          line: 12,
          column: 162
        }
      },
      "3": {
        start: {
          line: 14,
          column: 17
        },
        end: {
          line: 198,
          column: 1
        }
      },
      "4": {
        start: {
          line: 17,
          column: 18
        },
        end: {
          line: 17,
          column: 20
        }
      },
      "5": {
        start: {
          line: 18,
          column: 26
        },
        end: {
          line: 18,
          column: 27
        }
      },
      "6": {
        start: {
          line: 19,
          column: 19
        },
        end: {
          line: 19,
          column: 20
        }
      },
      "7": {
        start: {
          line: 20,
          column: 26
        },
        end: {
          line: 20,
          column: 28
        }
      },
      "8": {
        start: {
          line: 21,
          column: 19
        },
        end: {
          line: 21,
          column: 24
        }
      },
      "9": {
        start: {
          line: 23,
          column: 2
        },
        end: {
          line: 197,
          column: 3
        }
      },
      "10": {
        start: {
          line: 25,
          column: 6
        },
        end: {
          line: 29,
          column: 8
        }
      },
      "11": {
        start: {
          line: 31,
          column: 6
        },
        end: {
          line: 35,
          column: 8
        }
      },
      "12": {
        start: {
          line: 38,
          column: 6
        },
        end: {
          line: 45,
          column: 8
        }
      },
      "13": {
        start: {
          line: 46,
          column: 6
        },
        end: {
          line: 53,
          column: 8
        }
      },
      "14": {
        start: {
          line: 55,
          column: 6
        },
        end: {
          line: 55,
          column: 72
        }
      },
      "15": {
        start: {
          line: 56,
          column: 6
        },
        end: {
          line: 61,
          column: 8
        }
      },
      "16": {
        start: {
          line: 63,
          column: 6
        },
        end: {
          line: 63,
          column: 98
        }
      },
      "17": {
        start: {
          line: 64,
          column: 6
        },
        end: {
          line: 72,
          column: 8
        }
      },
      "18": {
        start: {
          line: 74,
          column: 6
        },
        end: {
          line: 81,
          column: 8
        }
      },
      "19": {
        start: {
          line: 82,
          column: 6
        },
        end: {
          line: 89,
          column: 8
        }
      },
      "20": {
        start: {
          line: 91,
          column: 6
        },
        end: {
          line: 97,
          column: 7
        }
      },
      "21": {
        start: {
          line: 92,
          column: 8
        },
        end: {
          line: 92,
          column: 60
        }
      },
      "22": {
        start: {
          line: 93,
          column: 8
        },
        end: {
          line: 93,
          column: 27
        }
      },
      "23": {
        start: {
          line: 94,
          column: 13
        },
        end: {
          line: 97,
          column: 7
        }
      },
      "24": {
        start: {
          line: 95,
          column: 8
        },
        end: {
          line: 95,
          column: 57
        }
      },
      "25": {
        start: {
          line: 96,
          column: 8
        },
        end: {
          line: 96,
          column: 26
        }
      },
      "26": {
        start: {
          line: 99,
          column: 6
        },
        end: {
          line: 109,
          column: 7
        }
      },
      "27": {
        start: {
          line: 100,
          column: 8
        },
        end: {
          line: 100,
          column: 87
        }
      },
      "28": {
        start: {
          line: 103,
          column: 8
        },
        end: {
          line: 108,
          column: 10
        }
      },
      "29": {
        start: {
          line: 111,
          column: 6
        },
        end: {
          line: 122,
          column: 8
        }
      },
      "30": {
        start: {
          line: 125,
          column: 6
        },
        end: {
          line: 129,
          column: 7
        }
      },
      "31": {
        start: {
          line: 126,
          column: 8
        },
        end: {
          line: 126,
          column: 60
        }
      },
      "32": {
        start: {
          line: 127,
          column: 13
        },
        end: {
          line: 129,
          column: 7
        }
      },
      "33": {
        start: {
          line: 128,
          column: 8
        },
        end: {
          line: 128,
          column: 57
        }
      },
      "34": {
        start: {
          line: 131,
          column: 6
        },
        end: {
          line: 137,
          column: 7
        }
      },
      "35": {
        start: {
          line: 132,
          column: 8
        },
        end: {
          line: 132,
          column: 87
        }
      },
      "36": {
        start: {
          line: 133,
          column: 8
        },
        end: {
          line: 136,
          column: 10
        }
      },
      "37": {
        start: {
          line: 140,
          column: 6
        },
        end: {
          line: 140,
          column: 66
        }
      },
      "38": {
        start: {
          line: 141,
          column: 6
        },
        end: {
          line: 149,
          column: 9
        }
      },
      "39": {
        start: {
          line: 142,
          column: 22
        },
        end: {
          line: 142,
          column: 32
        }
      },
      "40": {
        start: {
          line: 143,
          column: 29
        },
        end: {
          line: 143,
          column: 39
        }
      },
      "41": {
        start: {
          line: 144,
          column: 8
        },
        end: {
          line: 148,
          column: 9
        }
      },
      "42": {
        start: {
          line: 145,
          column: 10
        },
        end: {
          line: 145,
          column: 50
        }
      },
      "43": {
        start: {
          line: 147,
          column: 10
        },
        end: {
          line: 147,
          column: 98
        }
      },
      "44": {
        start: {
          line: 152,
          column: 6
        },
        end: {
          line: 152,
          column: 50
        }
      },
      "45": {
        start: {
          line: 154,
          column: 6
        },
        end: {
          line: 164,
          column: 8
        }
      },
      "46": {
        start: {
          line: 166,
          column: 6
        },
        end: {
          line: 170,
          column: 8
        }
      },
      "47": {
        start: {
          line: 174,
          column: 6
        },
        end: {
          line: 176,
          column: 7
        }
      },
      "48": {
        start: {
          line: 175,
          column: 8
        },
        end: {
          line: 175,
          column: 21
        }
      },
      "49": {
        start: {
          line: 177,
          column: 6
        },
        end: {
          line: 177,
          column: 66
        }
      },
      "50": {
        start: {
          line: 178,
          column: 6
        },
        end: {
          line: 186,
          column: 9
        }
      },
      "51": {
        start: {
          line: 179,
          column: 8
        },
        end: {
          line: 185,
          column: 9
        }
      },
      "52": {
        start: {
          line: 180,
          column: 10
        },
        end: {
          line: 184,
          column: 11
        }
      },
      "53": {
        start: {
          line: 187,
          column: 6
        },
        end: {
          line: 194,
          column: 8
        }
      },
      "54": {
        start: {
          line: 196,
          column: 6
        },
        end: {
          line: 196,
          column: 19
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 12,
            column: 33
          },
          end: {
            line: 12,
            column: 34
          }
        },
        loc: {
          start: {
            line: 12,
            column: 46
          },
          end: {
            line: 12,
            column: 162
          }
        },
        line: 12
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 14,
            column: 17
          },
          end: {
            line: 14,
            column: 18
          }
        },
        loc: {
          start: {
            line: 14,
            column: 85
          },
          end: {
            line: 198,
            column: 1
          }
        },
        line: 14
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 141,
            column: 45
          },
          end: {
            line: 141,
            column: 46
          }
        },
        loc: {
          start: {
            line: 141,
            column: 56
          },
          end: {
            line: 149,
            column: 7
          }
        },
        line: 141
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 178,
            column: 51
          },
          end: {
            line: 178,
            column: 52
          }
        },
        loc: {
          start: {
            line: 178,
            column: 62
          },
          end: {
            line: 186,
            column: 7
          }
        },
        line: 178
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 179,
            column: 73
          },
          end: {
            line: 179,
            column: 74
          }
        },
        loc: {
          start: {
            line: 180,
            column: 10
          },
          end: {
            line: 184,
            column: 11
          }
        },
        line: 180
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 12,
            column: 46
          },
          end: {
            line: 12,
            column: 162
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 12,
            column: 46
          },
          end: {
            line: 12,
            column: 74
          }
        }, {
          start: {
            line: 12,
            column: 78
          },
          end: {
            line: 12,
            column: 113
          }
        }, {
          start: {
            line: 12,
            column: 117
          },
          end: {
            line: 12,
            column: 138
          }
        }, {
          start: {
            line: 12,
            column: 142
          },
          end: {
            line: 12,
            column: 162
          }
        }],
        line: 12
      },
      "1": {
        loc: {
          start: {
            line: 14,
            column: 18
          },
          end: {
            line: 14,
            column: 72
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 14,
            column: 26
          },
          end: {
            line: 14,
            column: 72
          }
        }],
        line: 14
      },
      "2": {
        loc: {
          start: {
            line: 23,
            column: 2
          },
          end: {
            line: 197,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 24,
            column: 4
          },
          end: {
            line: 29,
            column: 8
          }
        }, {
          start: {
            line: 30,
            column: 4
          },
          end: {
            line: 35,
            column: 8
          }
        }, {
          start: {
            line: 37,
            column: 4
          },
          end: {
            line: 53,
            column: 8
          }
        }, {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 61,
            column: 8
          }
        }, {
          start: {
            line: 62,
            column: 4
          },
          end: {
            line: 72,
            column: 8
          }
        }, {
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 89,
            column: 8
          }
        }, {
          start: {
            line: 90,
            column: 4
          },
          end: {
            line: 122,
            column: 8
          }
        }, {
          start: {
            line: 123,
            column: 4
          },
          end: {
            line: 164,
            column: 8
          }
        }, {
          start: {
            line: 165,
            column: 4
          },
          end: {
            line: 170,
            column: 8
          }
        }, {
          start: {
            line: 172,
            column: 4
          },
          end: {
            line: 194,
            column: 8
          }
        }, {
          start: {
            line: 195,
            column: 4
          },
          end: {
            line: 196,
            column: 19
          }
        }],
        line: 23
      },
      "3": {
        loc: {
          start: {
            line: 91,
            column: 6
          },
          end: {
            line: 97,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 91,
            column: 6
          },
          end: {
            line: 97,
            column: 7
          }
        }, {
          start: {
            line: 94,
            column: 13
          },
          end: {
            line: 97,
            column: 7
          }
        }],
        line: 91
      },
      "4": {
        loc: {
          start: {
            line: 94,
            column: 13
          },
          end: {
            line: 97,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 94,
            column: 13
          },
          end: {
            line: 97,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 94
      },
      "5": {
        loc: {
          start: {
            line: 99,
            column: 6
          },
          end: {
            line: 109,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 99,
            column: 6
          },
          end: {
            line: 109,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 99
      },
      "6": {
        loc: {
          start: {
            line: 104,
            column: 10
          },
          end: {
            line: 106,
            column: 76
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 105,
            column: 12
          },
          end: {
            line: 105,
            column: 97
          }
        }, {
          start: {
            line: 106,
            column: 12
          },
          end: {
            line: 106,
            column: 76
          }
        }],
        line: 104
      },
      "7": {
        loc: {
          start: {
            line: 125,
            column: 6
          },
          end: {
            line: 129,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 125,
            column: 6
          },
          end: {
            line: 129,
            column: 7
          }
        }, {
          start: {
            line: 127,
            column: 13
          },
          end: {
            line: 129,
            column: 7
          }
        }],
        line: 125
      },
      "8": {
        loc: {
          start: {
            line: 127,
            column: 13
          },
          end: {
            line: 129,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 127,
            column: 13
          },
          end: {
            line: 129,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 127
      },
      "9": {
        loc: {
          start: {
            line: 131,
            column: 6
          },
          end: {
            line: 137,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 131,
            column: 6
          },
          end: {
            line: 137,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 131
      },
      "10": {
        loc: {
          start: {
            line: 144,
            column: 8
          },
          end: {
            line: 148,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 144,
            column: 8
          },
          end: {
            line: 148,
            column: 9
          }
        }, {
          start: {
            line: 146,
            column: 15
          },
          end: {
            line: 148,
            column: 9
          }
        }],
        line: 144
      },
      "11": {
        loc: {
          start: {
            line: 174,
            column: 6
          },
          end: {
            line: 176,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 174,
            column: 6
          },
          end: {
            line: 176,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 174
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    b: {
      "0": [0, 0, 0, 0],
      "1": [0],
      "2": [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "1daafc55ef017461610d0a23c47b57a33c7b9dcc"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1p97rk1ej9 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1p97rk1ej9();
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var calendarReducerInitialState = (cov_1p97rk1ej9().s[0]++, {
  LOADING: false,
  ERROR: false,
  occurrencesSize: 0,
  offset: 0,
  isTimeslot: false
});
cov_1p97rk1ej9().s[1]++;
var isCalendarRangeAvailable = function isCalendarRangeAvailable(action) {
  cov_1p97rk1ej9().f[0]++;
  cov_1p97rk1ej9().s[2]++;
  return (cov_1p97rk1ej9().b[0][0]++, action.data.productDateRange) && (cov_1p97rk1ej9().b[0][1]++, action.data.productDateRange.length) || (cov_1p97rk1ej9().b[0][2]++, action.data.firstDate) && (cov_1p97rk1ej9().b[0][3]++, action.data.lastDate);
};
cov_1p97rk1ej9().s[3]++;
var calendar = function calendar() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_1p97rk1ej9().b[1][0]++, (0, _assign.default)({}, calendarReducerInitialState));
  var action = arguments.length > 1 ? arguments[1] : undefined;
  cov_1p97rk1ej9().f[1]++;
  var newCalendar;
  var sectionByMonth;
  var dateRange = (cov_1p97rk1ej9().s[4]++, []);
  var occurrencesLength = (cov_1p97rk1ej9().s[5]++, 0);
  var nextOffset = (cov_1p97rk1ej9().s[6]++, 0);
  var newSectionByMonth = (cov_1p97rk1ej9().s[7]++, {});
  var isTimeslot = (cov_1p97rk1ej9().s[8]++, false);
  cov_1p97rk1ej9().s[9]++;
  switch (action.type) {
    case 'CALENDAR_BEFORE_LOAD':
      cov_1p97rk1ej9().b[2][0]++;
      cov_1p97rk1ej9().s[10]++;
      return _objectSpread(_objectSpread({}, state), {}, {
        LOADING: true,
        ERROR: false
      });
    case 'CALENDAR_BEFORE_LOAD_MONTHS':
      cov_1p97rk1ej9().b[2][1]++;
      cov_1p97rk1ej9().s[11]++;
      return {
        productId: action.productId,
        LOADING: true,
        ERROR: false
      };
    // put the loading state only at the day (cluster) level
    case 'CALENDAR_BEFORE_DAY_LOAD':
      cov_1p97rk1ej9().b[2][2]++;
      cov_1p97rk1ej9().s[12]++;
      sectionByMonth = _model.default.getSectionByMonthForDayChange(state.sectionByMonth, action.year, action.month, action.day, null, action.config);
      cov_1p97rk1ej9().s[13]++;
      return _objectSpread(_objectSpread(_objectSpread({}, state), {
        sectionByMonth: sectionByMonth
      }), {}, {
        LOADING: false,
        ERROR: false
      });
    case 'CALENDAR_LOAD_MONTHS_SUCCESS':
      cov_1p97rk1ej9().b[2][3]++;
      cov_1p97rk1ej9().s[14]++;
      newCalendar = _model.default.getMonths(action.data, action.config);
      cov_1p97rk1ej9().s[15]++;
      return _objectSpread(_objectSpread(_objectSpread({}, state), newCalendar), {}, {
        LOADING: false,
        ERROR: false
      });
    case 'CALENDAR_LOAD_MONTH_SUCCESS':
      cov_1p97rk1ej9().b[2][4]++;
      cov_1p97rk1ej9().s[16]++;
      newCalendar = _model.default.getMonth(action.data, action.year, action.month, action.config);
      cov_1p97rk1ej9().s[17]++;
      return _objectSpread(_objectSpread({}, state), {}, {
        sectionByMonth: _objectSpread(_objectSpread({}, state.sectionByMonth), newCalendar.sectionByMonth),
        LOADING: false,
        ERROR: false
      });
    case 'CALENDAR_LOAD_DAY_SUCCESS':
      cov_1p97rk1ej9().b[2][5]++;
      cov_1p97rk1ej9().s[18]++;
      sectionByMonth = _model.default.getSectionByMonthForDayChange(state.sectionByMonth, action.year, action.month, action.day, action.data, action.config);
      cov_1p97rk1ej9().s[19]++;
      return _objectSpread(_objectSpread(_objectSpread({}, state), {
        sectionByMonth: sectionByMonth
      }), {}, {
        LOADING: false,
        ERROR: false
      });
    case 'CALENDAR_LOAD_OCURRENCES_SUCCESS':
      cov_1p97rk1ej9().b[2][6]++;
      cov_1p97rk1ej9().s[20]++;
      if (action.data.performances) {
        cov_1p97rk1ej9().b[3][0]++;
        cov_1p97rk1ej9().s[21]++;
        occurrencesLength = action.data.performances.length;
        cov_1p97rk1ej9().s[22]++;
        isTimeslot = false;
      } else {
        cov_1p97rk1ej9().b[3][1]++;
        cov_1p97rk1ej9().s[23]++;
        if (action.data.timeslots) {
          cov_1p97rk1ej9().b[4][0]++;
          cov_1p97rk1ej9().s[24]++;
          occurrencesLength = action.data.timeslots.length;
          cov_1p97rk1ej9().s[25]++;
          isTimeslot = true;
        } else {
          cov_1p97rk1ej9().b[4][1]++;
        }
      }
      cov_1p97rk1ej9().s[26]++;
      if (isCalendarRangeAvailable(action)) {
        cov_1p97rk1ej9().b[5][0]++;
        cov_1p97rk1ej9().s[27]++;
        sectionByMonth = _model.default.getOccurrencesMonth(action.data, action.config);
        // calendarRange value is based on entire of performances if useProductDateRange is true in order to
        // handle case that performance limit is not set, so that only 5 performances were loaded into data
        cov_1p97rk1ej9().s[28]++;
        dateRange = _model.default.getMonths(action.useProductDateRange ? (cov_1p97rk1ej9().b[6][0]++, {
          calendarRange: [action.data.productDateRange[0], action.data.productDateRange[1]]
        }) : (cov_1p97rk1ej9().b[6][1]++, {
          calendarRange: [action.data.firstDate, action.data.lastDate]
        }), action.config);
      } else {
        cov_1p97rk1ej9().b[5][1]++;
      }
      cov_1p97rk1ej9().s[29]++;
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, state), {
        sectionByMonth: sectionByMonth
      }), dateRange), {}, {
        occurrencesSize: occurrencesLength,
        isTimeslot: isTimeslot,
        offset: 0,
        LOADING: false,
        ERROR: false
      });
    case 'CALENDAR_LOAD_MORE_OCURRENCES_SUCCESS':
      cov_1p97rk1ej9().b[2][7]++;
      cov_1p97rk1ej9().s[30]++;
      if (action.data.performances) {
        cov_1p97rk1ej9().b[7][0]++;
        cov_1p97rk1ej9().s[31]++;
        occurrencesLength = action.data.performances.length;
      } else {
        cov_1p97rk1ej9().b[7][1]++;
        cov_1p97rk1ej9().s[32]++;
        if (action.data.timeslots) {
          cov_1p97rk1ej9().b[8][0]++;
          cov_1p97rk1ej9().s[33]++;
          occurrencesLength = action.data.timeslots.length;
        } else {
          cov_1p97rk1ej9().b[8][1]++;
        }
      }
      // Get the section by month for the data provided by the server
      cov_1p97rk1ej9().s[34]++;
      if (isCalendarRangeAvailable(action)) {
        cov_1p97rk1ej9().b[9][0]++;
        cov_1p97rk1ej9().s[35]++;
        sectionByMonth = _model.default.getOccurrencesMonth(action.data, action.config);
        cov_1p97rk1ej9().s[36]++;
        dateRange = _model.default.getMonths({
          calendarRange: [action.data.firstDate, action.data.lastDate]
        }, action.config);
      } else {
        cov_1p97rk1ej9().b[9][1]++;
      }

      // Create a copy of the state to add the news clusters
      cov_1p97rk1ej9().s[37]++;
      newSectionByMonth = (0, _assign.default)({}, state.sectionByMonth);
      cov_1p97rk1ej9().s[38]++;
      (0, _entries.default)(sectionByMonth).forEach(function (section) {
        cov_1p97rk1ej9().f[2]++;
        var month = (cov_1p97rk1ej9().s[39]++, section[0]);
        var _ref = (cov_1p97rk1ej9().s[40]++, section[1]),
          clusters = _ref.clusters;
        cov_1p97rk1ej9().s[41]++;
        if (newSectionByMonth[month] === undefined) {
          cov_1p97rk1ej9().b[10][0]++;
          cov_1p97rk1ej9().s[42]++;
          newSectionByMonth[month] = {
            clusters: clusters
          };
        } else {
          cov_1p97rk1ej9().b[10][1]++;
          cov_1p97rk1ej9().s[43]++;
          newSectionByMonth[month].clusters = [].concat((0, _toConsumableArray2.default)(newSectionByMonth[month].clusters), (0, _toConsumableArray2.default)(clusters));
        }
      });

      // Increment the offset in one to the next page
      cov_1p97rk1ej9().s[44]++;
      nextOffset = (0, _parseInt2.default)(state.offset, 10) + 1;
      cov_1p97rk1ej9().s[45]++;
      return _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, state), {}, {
        offset: nextOffset
      }, {
        sectionByMonth: newSectionByMonth
      }), dateRange), {}, {
        occurrencesSize: occurrencesLength,
        LOADING: false,
        ERROR: false
      });
    case 'CALENDAR_LOAD_ERROR':
      cov_1p97rk1ej9().b[2][8]++;
      cov_1p97rk1ej9().s[46]++;
      return _objectSpread(_objectSpread({}, state), {}, {
        LOADING: false,
        ERROR: true
      });
    case 'GLOBAL_CHANGE_LANGUAGE':
      cov_1p97rk1ej9().b[2][9]++;
      cov_1p97rk1ej9().s[47]++;
      // STX-100377: Loop over sectionByMonth of state and set cluster after changing language
      if (!state.sectionByMonth) {
        cov_1p97rk1ej9().b[11][0]++;
        cov_1p97rk1ej9().s[48]++;
        return state;
      } else {
        cov_1p97rk1ej9().b[11][1]++;
      }
      cov_1p97rk1ej9().s[49]++;
      newSectionByMonth = (0, _assign.default)({}, state.sectionByMonth);
      cov_1p97rk1ej9().s[50]++;
      (0, _entries.default)(state.sectionByMonth).forEach(function (section) {
        cov_1p97rk1ej9().f[3]++;
        cov_1p97rk1ej9().s[51]++;
        newSectionByMonth[section[0]].clusters = section[1].clusters.map(function (cluster) {
          cov_1p97rk1ej9().f[4]++;
          cov_1p97rk1ej9().s[52]++;
          return _section.ClusterModel.changeLanguage(cluster, action.language, action.defaultLanguage);
        });
      });
      cov_1p97rk1ej9().s[53]++;
      return _objectSpread(_objectSpread(_objectSpread({}, state), {
        sectionByMonth: newSectionByMonth
      }), {}, {
        LOADING: false,
        ERROR: false
      });
    default:
      cov_1p97rk1ej9().b[2][10]++;
      cov_1p97rk1ej9().s[54]++;
      return state;
  }
};
var _default = exports.default = calendar;